// Hex Color를 50% 밝게 만드는 함수
export const lightenHexColor = (hexColor?: string | null) => {
  if (!hexColor || !/^#?[0-9A-Fa-f]{6}$/.test(hexColor)) {
    return '';
  }

  try {
    hexColor = hexColor.replace(/^#/, '');

    let r = parseInt(hexColor.substring(0, 2), 16);
    let g = parseInt(hexColor.substring(2, 4), 16);
    let b = parseInt(hexColor.substring(4, 6), 16);

    r = Math.min(255, Math.floor(r + (255 - r) * 0.5));
    g = Math.min(255, Math.floor(g + (255 - g) * 0.5));
    b = Math.min(255, Math.floor(b + (255 - b) * 0.5));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  } catch (error) {
    return '';
  }
};
